<mpro-dropdown
  title="Age group & generation"
  [inputValue]="inputValue"
  (openDropdownAction)="onDropdownOpened()"
  [showInfo]="multiSelect"
>
  <mpro-dropdown-item
    [leftText]="defaultValue"
    (itemClicked)="reset()"
    [selected]="defaultValue === inputValue"
  ></mpro-dropdown-item>
  <mpro-age-group-selector
    class="dropdown-container"
    #ageGroup
    [horizontal]="true"
    [inputValue]="dataFilters.ageGroup.displayValue()"
    [userGroups]="(dashboardService.getCustomAgeGroups() | async) || []"
    [systemGroups]="authResources.ageGroups"
    [multiSelect]="multiSelect"
    [selectedAgeGroups]="selectedAgeGroups"
    (groupClicked)="ageGroupChanged($event)"
    (multiItemSelection)="ageGroupChanged($event)"
    (mouseenter)="
      hideGenerations
        ? toggleDropdowns([ageGroup])
        : toggleDropdowns([ageGroup, generations])
    "
    (ageGroupsChanged)="loadRangeCustomFilters()"
  ></mpro-age-group-selector>
  <mpro-dropdown
    *ngIf="!hideGenerations"
    class="dropdown-container"
    #generations
    title="Generation"
    [horizontal]="true"
    (mouseenter)="
      hideGenerations
        ? toggleDropdowns([ageGroup])
        : toggleDropdowns([generations, ageGroup])
    "
  >
    <mpro-dropdown-item
      class="system-group"
      *ngFor="let g of authResources.generations"
      [leftText]="g.name"
      [selected]="isGenerationSelected(g)"
      (itemClicked)="generationsChanged(g.name)"
      [readonly]="isGenerationsDisabled()"
      (mouseenter)="onMouseEnter($event)"
      (mouseleave)="onMouseLeave()"
    >
    </mpro-dropdown-item>
  </mpro-dropdown>
</mpro-dropdown>
<div #tooltip hidden="true">
  <mpro-tooltip [options]="tooltipOptions"></mpro-tooltip>
</div>
